import { NodeDataMapping, WorkflowNode } from "../../types/workflow";

const isDynamicConfig = (serviceName: string) => {
    return ["airtable", "hubspot"].includes(serviceName);
};

const getShouldRefetchConfig = (workflowNode: WorkflowNode = {node: {}}, dataMappings: Partial<NodeDataMapping>[] = []) => {
    const { node } = workflowNode;
    // if (!isDynamicConfig(node?.service || '')) return false;

    try {
        const config = node?.config ? JSON.parse(node?.config) : {};
        const { base_id: baseIdConfig } = config;
        const nodeConfigIsSet = !!baseIdConfig;

        const baseIdDataMapping = dataMappings?.find(mapping => mapping.end_node_data === 'base_id');
        const tableIdDataMapping = dataMappings?.find(mapping => mapping.end_node_data === 'table_id');
        const baseIdDataMappingIsSet = !!baseIdDataMapping?.start_node_data;
        const tableIdDataMappingIsSet = !!tableIdDataMapping?.start_node_data;
        const nodeMappingIsSet = baseIdDataMappingIsSet && tableIdDataMappingIsSet;

        return nodeConfigIsSet || nodeMappingIsSet;
    } catch(e) {
        console.log(e);
    }
}

export {
    getShouldRefetchConfig
};
